module.exports = __webpack_public_path__ + "static/media/Calibri.5d7c31b2.ttf";